import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SignWithStockAmount } from './sign-with-stock-amount';
import { LoadingService } from '../../../../../../services/loading.service';
import { SnackService } from '../../../../../../services/snack.service';
import { Observable } from 'rxjs';
import { _get } from '../../../../../../services/base.service';

@Injectable({
  providedIn: 'root',
})
export class SignForCompanyControllerRequestService {
  private static BASE_URL = '/signs';
  private readonly get: <T>(
    path: string,
    deserialize: (response: any) => T
  ) => Observable<T>;
  private readonly deserialize = (res) => res as SignWithStockAmount[];

  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };
    this.get = _get(
      SignForCompanyControllerRequestService.BASE_URL,
      requestServices
    );
  }

  public getForCompanyWithStockAmount(
    companyId: number
  ): Promise<SignWithStockAmount[]> {
    return this.get(
      `/forCompanyWithStockAmount/${companyId}`,
      this.deserialize
    ).toPromise();
  }
}
